import { Component,EventEmitter, OnInit, HostListener } from '@angular/core';
import{AppServiceService} from '../app-service.service';
var player;
var done = false;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
public news = [
  { title:"Acknowledgement Of Outstanding Performance",newsId:'newsid1'},
  { title:"Cash Awards For Academic Excellence",newsId:'newsid3'},
  { title:"Quiz Competition",newsId:'newsid4'},
  { title:"Annual Cultural Activities",newsId:'newsid5'},
  { title:"Stalls At Annual Fest", newsId:'newsid6'}
];
@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
     if (event.keyCode == 27) {
      
     }
  }
  constructor(private service:AppServiceService) { }

  ngOnInit() {
  }
  
  showBrochure() {
    window.open('assets/brochure.pdf', '_blank')
  }

  openYouTube() {
    window.open('https://youtube.com/@vvspucgoldenjubilee', '_blank')
  }

  openMagazine() {
    window.open('assets/pdf/2025/VidyaSuvarna-final.pdf', '_blank')
  }

  openAlumniRegistrationForm() {
    window.open('https://forms.gle/q4JE9D7RqCgnUZrW8', '_blank')
  }

  openRegistrationForm() {
    window.open('https://docs.google.com/forms/d/18R7GprImoUwWBrya4HjT9DNpFL9xcnmzjCKNWaXH2iU/edit', '_blank')
  }


goTonews(newsid){

}

}
